<template>
  <aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- Sidebar user panel -->
      <div class="user-panel mb-5">
        <div class="pull-left image">
          <img
            src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
            class="img-circle"
            alt="User Image"
          />
        </div>
        <div class="pull-left info" v-if="information">
          <p>{{ information.nama }}</p>
          <a href="#"><i class="fa fa-circle text-success"></i> Online</a>
        </div>
        <div class="pull-left info" v-else>
          <p>loading...</p>
          <a href="#"><i class="fa fa-circle text-success"></i> Online</a>
        </div>
      </div>
      <!-- sidebar menu: : style can be found in sidebar.less -->
      <ul class="sidebar-menu" data-widget="tree">
        <li class="header">MAIN NAVIGATION</li>
        <li>
          <router-link to="/"
            ><i class="fa fa-book"></i> <span>Dashboard</span>
          </router-link>
        </li>
        <li class="treeview">
          <a href="#">
            <i class="fa fa-dashboard"></i> <span>User</span>
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/user"
                ><i class="fa fa-circle-o"></i><span> User Profile</span>
              </router-link>
            </li>
            <li>
              <router-link to="/user-status"
                ><i class="fa fa-circle-o"></i> <span>Status</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link to="/kelas">
            <i class="fa fa-book"></i> <span>Kelas</span>
          </router-link>
        </li>
        <li class="header">Formulir</li>
        <li class="treeview">
          <a href="">
            <i class="fa fa-share"></i> <span>Pengiriman Formulir</span>
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"></i>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/formulir/surat-tugas">
                <i class="fa fa-circle-o"></i> <span>Surat Tugas</span>
              </router-link>
            </li>
            <li>
              <router-link to="/formulir/surat-keterangan">
                <i class="fa fa-circle-o"></i> <span>Surat Keterangan</span>
              </router-link>
            </li>
          </ul>
        </li>

        <!-- <li class="header">Bussiness</li>
        <li>
          <a href="https://adminlte.io/docs"
            ><i class="fa fa-book"></i> <span>Pembayaran</span></a
          >
        </li> -->

        <li class="header">Terms and Conditions</li>
        <li>
          <a href="#"
            ><i class="fa fa-book"></i> <span>Terms and Conditions</span>
          </a>
        </li>

        <li>
          <a href="https://rsudbandungkiwari.or.id/hubungi-kami/"
            ><i class="fa fa-book"></i> <span>Hubungi Kami</span>
          </a>
        </li>
      </ul>
    </section>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
export default {
  props: ["information"],
}
</script>
